<template>
  <div class="dialog-body flex pt-2 pb-4" style="height:100%;">
    <div class="left-pane px-2">
      <div class="pdfViewer">
        <div v-if="pdfSrc" style='width:100%;height:100%;'>
          <map-pdf-viewer
            :pdfUrl="pdfSrc"
            :highlights="highlights"
            :activeId="activeField"
          />
          <!--
          <embed
            :src="pdfSrc"
            type="application/pdf"
            width="100%"
            height="100%"
          />-->
        </div>
      </div>
    </div>

    <div class="right-pane pb-2 px-6">
      <div class="baseInfo text-12 py-2">
        <div class="text-16 text-bold text-gray-800 mb-2">
          ファイル情報
        </div>
        <!-- <div class="flex mb-1">
          <div class="aiOcrLabel">
            OCR No.
          </div>
          <div>123456789</div>
        </div> -->
        <div class="flex mb-1">
          <div class="aiOcrLabel">
            {{ $t('List.Attach File')}}
          </div>
          <div>{{ payload.document.documentName }}</div>
        </div>
        <div class="flex mb-1">
          <div class="aiOcrLabel">
            帳票種別
          </div>
          <div>
            {{ documentLink }}
          </div>
        </div>
      </div>

      <div class="text-16 text-bold text-gray-800 mb-4 mt-2">
        OCRの読取結果を元に情報を更新
        <span class="text-12 ml-4 text-gray-600">( 対象 ) {{ tradingTitle }} : {{ processName }}</span>
      </div>
      <el-form
        :model="formModel"
        ref="form"
        :rules="rules"
        class="flex"
        style="minHeight:0"
        :validate-on-rule-change="false"
      >
        <el-tabs
          v-model="activeTab"
          type="border-card"
          class="tabs-fill"
          @tab-click="handleTabClick"
        >
          <el-tab-pane label="ヘッダー項目" name='single'>
            <!-- ヘッダー項目 -->
            <div class="pane-scroll ai-ocr-items">
              <TwTable
                :cols="singleSchema"
                :tableData="formModel.tableData"
                :loading="loading && isSetting"
                :offsetY="450"
              >
                <template #twFieldName="{ row }">
                  <div
                    :title="row.twFieldPath"
                    @mouseenter="setHighlightItem(row, 'single')"
                    @mouseleave="clearHighlightItem(row)"
                  >
                    {{ row.twFieldLabel }}
                    <span v-if="row.ocrFieldSetPage && row.ocrFieldValue !==''">
                      <i class="el-icon-tickets" style="color: #213b6c"></i>
                    </span>
                  </div>
                  <div class="text-gray-600">{{ row.twFieldValue }}</div>
                </template>

                <template #twNewValue="{ row, $index }">
                  <div class="flex align-center">
                    <el-form-item :prop="`tableData.${$index}.twNewValue`" :label="row.twFieldLabel">
                      <el-date-picker
                        v-if="row.twFieldType === 'date'"
                        v-model="row.twNewValue"
                        type="date"
                        placeholder="日付を選択"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @input="handleInput(row)"
                      />
                      <el-input
                        v-else-if="row.twFieldType === 'number'"
                        v-model.number="row.twNewValue"
                        :type="row.twFieldType"
                        :placeholder="row.ocrFieldValue ? `AI-OCR val: ${row.ocrFieldValue}` : ''"
                        @input="handleInput(row)"
                      />
                      <el-input
                        v-else
                        v-model="row.twNewValue"
                        :type="textType(row.twFieldPath)"
                        :placeholder="row.ocrFieldValue ? `AI-OCR val: ${row.ocrFieldValue}` : ''"
                        @input="handleInput(row)"
                      />
                    </el-form-item>
                    <el-tooltip
                      :disabled="!(row.isChanged || row.hasOcrDiff)"
                      :content="row.isChanged
                        ? '値を手動で変更しています'
                        : 'すでに入力済みの値をOCRの読取結果で修正しています。必要に応じて修正ください。'"
                      placement="top"
                      :append-to-body="true"
                    >
                    <i
                      v-show="row.isChanged || row.hasOcrDiff"
                      :class="row.isChanged ? 'el-icon-warning' : 'el-icon-warning'"
                      class="ml-3"
                      :style="row.isChanged ? 'color:#409EFF;font-size:16px;' : 'color:#E6A23C;font-size:16px;'"
                    />
                    </el-tooltip>
                  </div>
                </template>
              </TwTable>
            </div>
          </el-tab-pane>

          <el-tab-pane label="明細項目" name='multiple'>
            <!-- <div class="mb-3 text-14 text-gray-600">※明細項目は読み取った値から編集できません。</div> -->
            <!-- 明細項目 -->
            <div
              v-if="formModel.itemsTableData.length === 0"
              class="flex align-item justify-center"
            >
              <div class="text-12 p-4">
                データがありません
              </div>
            </div>
            <div class="pane-scroll ai-ocr-table-items" v-else>
              <div class="m-2 text-gray-800 text-13 text-bold">
                Total {{ formModel.itemsTableData.length }} Items
              </div>
              <!-- 行（商品）ごとにカード風に表示（任意の装飾） -->
              <div
                  v-for="(row, rowIndex) in formModel.itemsTableData"
                  :key="rowIndex"
                  class="row-card mb-5 px-4 py-2"
                  :class="{ 'row-card--loading' : isClosing }"
              >
                <div v-if="isClosing" class="row-card__shimmer" />
                <div class="flex">
                  <div class="my-2 text-gray-600 text-bold text-12 flex-grow">
                    <i class="el-icon-box mr-1" />
                    {{ `${rowIndex + 1}つめのアイテム`}}
                  </div>
                  <el-button
                    v-if="!isClosing"
                    type='text'
                    icon='el-icon-close'
                    @click='handleCloseItems(rowIndex)'
                  ></el-button>
                </div>
                <div class="fields">
                  <!-- スキーマで回す -->
                  <div
                    v-for="field in tableSchemas[selectedTableSchema]"
                    :key="field.key"
                    class="field-col"
                    :style="colStyle(field)"
                  >
                    <div class="flex align-center" style="height:100%">
                      <div v-if="!field.editable" style="width:100%">
                        <label
                          class="el-form-item__label"
                        >
                          {{ field.label }}
                        </label>
                        <div
                          class="flex align-center justify-center pa-2"
                          style="width:100%;height:40px;border:1px solid #EDEDF4;borderRadius:6px;"
                        >
                          {{ formModel.itemsTableData[rowIndex][field.prop] }}
                        </div>
                      </div>
                      <el-form-item
                        v-else
                        :prop="`itemsTableData.${rowIndex}.${normalizeKey(field.key)}`"
                        :label="field.label"
                      >
                        <div
                          @mouseenter="setHighlightItem(row, selectedTableSchema)"
                          @mouseleave="clearHighlightItem(row)"
                        >
                          <!-- <el-select
                            v-if='row.twFieldType === "SYS_MST_CURRENCY"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangeCurrency( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for='unit in SYS_MST_CURRENCY'
                              :key='unit.alphabeticCode'
                              :label='unit.symbol'
                              :value='unit.symbol'
                            >
                            </el-option>
                          </el-select> -->
                          <el-select
                            v-if='field.key === "containerCode"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangeContainerType( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for='type in SYS_MST_CONTAINER_TYPE'
                              :key='type.code'
                              :label='type.description'
                              :value='type.code'
                            >
                            </el-option>
                          </el-select>
                          <el-select
                            v-else-if='field.key === "ocrCargoGrossWeightUnit"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangeUnit( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for='unit in CARGO_GROSS_WEIGHT_UNIT_VARIABLES'
                              :key='unit.code'
                              :label='unit.label'
                              :value='unit.code'
                            >
                            </el-option>
                          </el-select>
                          <el-select
                            v-else-if='field.key === "ocrCargoGrossVolumeUnit"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangeUnit( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for='unit in CARGO_GROSS_VOLUME_UNIT_VARIABLES'
                              :key='unit.code'
                              :label='unit.label'
                              :value='unit.code'
                            >
                            </el-option>
                          </el-select>
                          <el-select
                            v-else-if='field.key === "ocrPlMeasurementUnit"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangeMsmtUnit( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for="unit in SYS_MST_UNIT"
                              :key="unit.id"
                              :label="unit.value"
                              :value="unit.value">
                            </el-option>
                          </el-select>
                          <el-select
                            v-else-if='field.key === "ocrPlWeightUnit"'
                            v-model='formModel.itemsTableData[rowIndex][field.prop]'
                            @change='val => onChangWeightUnit( val, rowIndex, field.key)'
                            clearable
                          >
                            <el-option
                              v-for="unit in SYS_MST_UNIT"
                              :key="unit.id"
                              :label="unit.value"
                              :value="unit.value">
                            </el-option>
                          </el-select>
                          <el-date-picker
                            v-else-if="row.twFieldType === 'date'"
                            v-model="row.twNewValue"
                            type="date"
                            placeholder="日付を選択"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @input="handleInput(row)"
                          />
                          <el-input
                            v-else-if="row.twFieldType === 'number'"
                            v-model.number="formModel.itemsTableData[rowIndex][field.prop]"
                            :type="field.type"
                            :placeholder="itemsTableData[rowIndex][field.prop]"
                            :maxlength="field.maxLength != null ? field.maxLength : undefined"
                            :disabled="!!field.disabled"
                            @input="onInput(rowIndex, field)"
                          />
                          <el-input
                            v-else
                            v-model="formModel.itemsTableData[rowIndex][field.prop]"
                            :type="field.type"
                            :placeholder="itemsTableData[rowIndex][field.prop]"
                            :maxlength="field.maxLength != null ? field.maxLength : undefined"
                            :disabled="!!field.disabled"
                            @input="onInput(rowIndex, field)"
                          />
                        </div>
                      </el-form-item>
                      <el-tooltip
                        content="値を手動で変更しています"
                        placement="top"
                        :append-to-body="true"
                      >
                      <i
                        v-show="isDirtyRow(rowIndex, field.key)"
                        class="el-icon-warning ml-3"
                        :style="row.isChanged ? 'color:#409EFF;font-size:16px;' : 'color:#E6A23C;font-size:16px;'"
                      />
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </div>
</template>

<script>
import _, { isEmpty } from 'lodash';
import dayjs from 'dayjs';
import {
  getCurrentInstance,
  defineComponent,
  onMounted,
  ref,
  computed,
  watch,
  reactive,
} from '@vue/composition-api';

import {
  LANGUAGE_CODE,
  CARGO_GROSS_WEIGHT_UNIT_VARIABLES,
  CARGO_GROSS_VOLUME_UNIT_VARIABLES,
  PROCESS_TYPE,
} from 'lib-tw-common';
import schemaICREQ from '@/dictionaries/processes/icreq.json';
import schemaECREQ from '@/dictionaries/processes/ecreq.json';

import { $api } from '@/store/ApiClient';

import { generateUuid } from '@/utils/searchUtil.js';
import { createGoodsLine } from '@/utils/createGoodsLine';
import { processNames } from '@/dictionaries/map.js';

import { useLakeelValidation } from '@/composables/useLakeelValidation';
import { useBffAiOcrInitial } from '@/composables/useBffAiOcrInitial.js';

import TwTable from '@/components/vue3/TwTable.vue';

import mapPdfViewer from './mapPdfViewer.vue';

export default defineComponent({
  name: 'MapAiOcr',
  components: {
    TwTable,
    mapPdfViewer,
  },
  props: {
    payload: {
      type: Object,
      required: true,
    },
    validationCheck: {
      type: Function,
      required: true,
    },
    processType: {
      type: String,
      required: true,
      validator: (value) => {
        return [
          PROCESS_TYPE.ICREQ,
          PROCESS_TYPE.ECREQ,
        ].includes(value);
      }
    }
  },
  setup(props, { emit, root }) {
    const language = root.$store.state.locale;
    const lang = _.get(LANGUAGE_CODE, `${language}`, 'ja');

    const SYS_MST_CONTAINER_TYPE = _.get(
      root.$store.state.systemProperties,
      'SYS_MST_CONTAINER_TYPE',
    );
    const SYS_MST_UNIT = root.$store.getters.getSysMstUnit;
    const SYS_MST_CURRENCY = root.$store.getters.getSysMstCurrency;

    const SYS_MST_PORT_AND_PLACE = root.$store.getters.getSysMstPortAndPlace;
    // 梱包種類マスタ（Packing Unit のプルダウンと同じ一覧。code＝荷姿ID、value＝表示名）PB-2021
    const SYS_MST_PACKAGE_TYPE = root.$store.getters.getSysMstPackageType;

    const singleSchema = [
      {
        prop: 'twFieldName',
        label:
          lang === 'ja' ? 'プロセス項目/既存の値' : 'TradeWaltz Label / Value',
      },
      {
        prop: 'twNewValue',
        label:
          lang === 'ja' ? '上書き登録する項目の値' : 'TradeWaltz New Value',
        editable: true,
      },
    ];

    const schemaMapping = {
      // プロセス種別ごとの単一項目定義マッピング
      [PROCESS_TYPE.ICREQ]: schemaICREQ,
      [PROCESS_TYPE.ECREQ]: schemaECREQ,
    };


    const tableSchemas = {
      goodsLine: [
        {
          prop: 'ocrGoodsShortName',
          key: 'ocrGoodsShortName',
          label: 'Goods Short Name',
          type: 'text',
          editable: true,
          width: '250px',
        },
        {
          prop: 'ocrGoodsRefNo1',
          key: 'ocrGoodsRefNo1',
          type: 'text',
          label: 'Goods Reference1',
          editable: true,
        },
        {
          prop: 'ocrCountryOfOriginNames',
          key: 'ocrCountryOfOriginNames',
          type: 'text',
          label: 'Country of Origin Name(Origin)',
          editable: true,
        },
        // OCR未対応のため一旦非表示
        // {
        //   prop: 'ocrHscode',
        //   key: 'ocrHscode',
        //   type: 'text',
        //   label: 'HS Code',
        //   editable: true,
        // },
        {
          prop: 'ocrQuantity1',
          key: 'ocrQuantity1',
          type: 'number',
          label: 'Quantity',
          editable: true,
        },
        {
          prop: 'ocrUnit',
          key: 'ocrUnit',
          type: 'text',
          label: 'Unit',
          editable: true,
        },
        {
          prop: 'ocrUnitPrice',
          key: 'ocrUnitPrice',
          type: 'number',
          label: 'Price',
          editable: true,
        },
        {
          prop: 'ocrImCustomsCurrencies',
          key: 'ocrImCustomsCurrencies',
          type: 'SYS_MST_CURRENCY',
          label: 'Currency',
          editable: true,
        },
        {
          prop: 'ocrAmountPerItem',
          key: 'ocrAmountPerItem',
          type: 'number',
          label: 'Amount',
          editable: true,
        },
      ],

      containerSeals: [
        {
          prop: 'containerCode',
          key: 'containerCode',
          label: 'Container Type',
          type: 'select',
          editable: true,
        },
        {
          prop: 'ocrContainerNo',
          key: 'ocrContainerNo',
          label: 'Container No',
          type: 'text',
          editable: true,
        },
        {
          prop: 'ocrCargoGrossWeight',
          key: 'ocrCargoGrossWeight',
          label: 'Cargo Gross Weight',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrCargoGrossWeightUnit',
          key: 'ocrCargoGrossWeightUnit',
          label: 'Cargo Gross Weight Unit',
          type: 'select',
          editable: true,
        },
        {
          prop: 'ocrCargoGrossVolume',
          key: 'ocrCargoGrossVolume',
          label: 'Cargo Gross Volume',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrCargoGrossVolumeUnit',
          key: 'ocrCargoGrossVolumeUnit',
          label: 'Cargo Gross Volume Unit',
          type: 'select',
          editable: true,
        },
      ],
      goodsLinePacking: [
        {
          prop: 'ocrGoodsShortName',
          key: 'ocrGoodsShortName',
          label: 'Goods Short Name',
          type: 'text',
          editable: true,
          width: '250px',
        },
        {
          prop: 'ocrGoodsRefNo1',
          key: 'ocrGoodsRefNo1',
          label: 'Reference No.1',
          type: 'text',
          editable: true,
        },
        // 一旦非表示
        // {
        //   prop: 'ocrHscode',
        //   key: 'ocrHscode',
        //   type: 'text',
        //   label: 'HS Code',
        //   editable: true,
        // },
        {
          prop: 'ocrPlcontainerNo',
          key: 'ocrPlcontainerNo',
          label: 'Container No.',
          type: 'text',
          editable: true,
        },
        {
          prop: 'ocrPlQuantity1',
          key: 'ocrPlQuantity1',
          label: 'No. of Packing',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrPlPackingName',
          key: 'ocrPlPackingName',
          label: 'Packing Unit',
          type: 'text',
          editable: true,
        },
        {
          prop: 'ocrPlPcsNumber',
          key: 'ocrPlPcsNumber',
          label: 'No. of Contents',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrPlInnerPackingName',
          key: 'ocrPlInnerPackingName',
          label: 'Inner Packing Unit',
          type: 'text',
          editable: true,
        },
        {
          prop: 'ocrPlNetTotal',
          key: 'ocrPlNetTotal',
          label: 'TTL N. WT',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrPlGrossTotal',
          key: 'ocrPlGrossTotal',
          label: 'TTL G. WT',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrPlWeightUnit',
          key: 'ocrPlWeightUnit',
          label: 'Weight Unit',
          type: 'text',
          editable: true,
        },
        {
          prop: 'ocrPlGrossMeasurementTotal',
          key: 'ocrPlGrossMeasurementTotal',
          label: 'Gross MSMT',
          type: 'number',
          editable: true,
        },
        {
          prop: 'ocrPlMeasurementUnit',
          key: 'ocrPlMeasurementUnit',
          label: 'MSMT Unit',
          type: 'text',
          editable: true,
        },
      ]
    };

    const FIELD_MAP = {
      ocrGoodsShortName: 'goodsGrp.goodsShortName',
      ocrHscode: 'keyGrp.goodsValue',
      ocrQuantity1: 'quantityGrp.quantity1',
      ocrGoodsRefNo1: 'goodsGrp.goodsRefNo1',
      ocrCountryOfOriginNames: 'goodsGrp.countryOfOriginName',
      ocrUnit: 'quantityGrp.unit1',
      ocrUnitPrice: 'priceGrp.price',
      ocrAmountPerItem: 'amountGrp.amount',
      ocrImCustomsCurrencies: 'priceGrp.currency',
    };
    const FIELD_MAP_CONTAINER = {
      ocrContainerSize: 'containerSize',
      ocrContainerType: 'containerType',
      ocrContainerNo: 'containerNo',
      ocrCargoGrossWeight: 'cargoGrossWeight',
      cargoGrossWeightUnit: 'cargoGrossWeightUnit',
      ocrCargoGrossVolume: 'cargoGrossVolume',
      cargoGrossVolumeUnit: 'cargoGrossVolumeUnit',
    };
    const FIELD_MAP_GOODS_LINE_PACKING = {
      ocrGoodsShortName: 'goodsGrp.goodsShortName',
      ocrHscode: 'keyGrp.goodsValue',
      ocrGoodsRefNo1: 'goodsGrp.goodsRefNo1',
      ocrPlcontainerNo: 'netGrossMeasurementGrp.containerNo',
      ocrPlQuantity1: 'netGrossMeasurementGrp.numberOfPackages',
      ocrPlPcsNumber: 'netGrossMeasurementGrp.numberOfContents',
      ocrPlPackingId: 'netGrossMeasurementGrp.packingId',
      ocrPlPackingName: 'netGrossMeasurementGrp.packing',
      ocrPlInnerPackingId: 'netGrossMeasurementGrp.innerPackingId',
      ocrPlInnerPackingName: 'netGrossMeasurementGrp.innerPacking',
      ocrPlNetTotal: 'netGrossMeasurementGrp.netTotal',
      ocrPlGrossTotal: 'netGrossMeasurementGrp.grossTotal',
      ocrPlWeightUnit: 'netGrossMeasurementGrp.weightUnit',
      ocrPlGrossMeasurementTotal: 'netGrossMeasurementGrp.grossMeasurementTotal',
      ocrPlMeasurementUnit: 'netGrossMeasurementGrp.measurementUnit',
    };

    const ITEMS_TYPE_MAP = {
      ocrGoodsShortName: 'text',
      ocrHscode: 'text',
      ocrQuantity1: 'number',
      ocrItemNo: 'text',
      ocrCountryOfOriginNames: 'text',
      unit: 'text',
      ocrUnitPrice: 'number',
      ocrAmountPerItem: 'number',
      ocrImCustomsCurrencies: 'text',
      ocrContainerSize: 'text',
      ocrContainerType: 'text',
      ocrContainerNo: 'text',
      ocrCargoGrossWeight: 'number',
      ocrCargoGrossWeightUnit: 'number',
      ocrCargoGrossVolume: 'number',
      ocrCargoGrossVolumeUnit: 'number',
      ocrGoodsRefNo1: 'text',
      ocrPlContainerNo: 'text',
      ocrPlQuantity1: 'number',
      ocrPlUnit1: 'text',
      ocrPlPcsNumber: 'number',
      ocrPlPcsUnit: 'text',
      ocrPlPackingId: 'text',
      ocrPlPackingName: 'text',
      ocrPlInnerPackingId: 'text',
      ocrPlInnerPackingName: 'text',
      ocrPlNetTotal: 'number',
      ocrPlGrossTotal: 'number',
      ocrPlWeightUnit: 'text',
      ocrPlGrossMeasurementTotal: 'number',
      ocrPlMeasurementUnit: 'text',

    };

    const VALIDATION_BY_KEY = {
      ocrGoodsShortName: ['tw-isMaxLength200'],
      ocrQuantity1: [
        'tw-isNumber',
        'tw-isIntegerDigit11',
        'tw-isDecimalDigit4',
      ],
      ocrGoodsRefNo1: ['tw-isMaxLength20'],
      ocrCountryOfOriginNames: ['tw-isMaxLength100'],
      ocrUnit: ['tw-isMaxLength10'],
      ocrUnitPrice: [
        'tw-isNumber',
        'tw-isIntegerDigit13',
        'tw-isDecimalDigit2',
      ],
      ocrAmountPerItem: [
        'tw-isNumber',
        'tw-isIntegerDigit13',
        'tw-isDecimalDigit2',
      ],
      ocrImCustomsCurrencies: ['tw-isMaxLength10'],
      // ocrContainerSize: ['tw-isMaxLength10'],
      ocrContainerSize: [],
      ocrContainerType: ['tw-isMaxLength10'],
      ocrCargoGrossWeight: [
        'tw-isNumber',
        'tw-isIntegerDigit11',
        'tw-isDecimalDigit4',
      ],
      ocrCargoGrossWeightUnit: [],
      ocrCargoGrossVolume: [
        'tw-isNumber',
        'tw-isIntegerDigit11',
        'tw-isDecimalDigit4',
        'tw-isPositiveNumber',
      ],
      ocrCargoGrossVolumeUnit: [],
      ocrContainerNo: ['tw-isMaxLength20'],

      // ocrHscode:[],
      ocrPlcontainerNo:['tw-isMaxLength20'],
      ocrPlPackingName: ['tw-isMaxLength100'],
      ocrPlInnerPackingName: ['tw-isMaxLength100'],
      ocrPlQuantity1:[
        'tw-isNumber',
        'tw-isIntegerDigit15',
      ],
      ocrPlPcsNumber:[
        'tw-isNumber',
        'tw-isIntegerDigit15',
      ],
      ocrPlNetTotal:[
        'tw-isNumber',
        'tw-isIntegerDigit11',
        'tw-isDecimalDigit4',
      ],
      ocrPlGrossTotal:[
        'tw-isNumber',
        'tw-isIntegerDigit11',
        'tw-isDecimalDigit4',
      ],
      ocrPlWeightUnit:[
        'tw-isMaxLength20'
      ],
      ocrPlGrossMeasurementTotal:[
        'tw-isNumber',
        'tw-isIntegerDigit9',
        'tw-isDecimalDigit6',
      ],
      ocrPlMeasurementUnit:[
        'tw-isMaxLength20'
      ],

    };

    const process = Object.values(processNames).find(process => {
      const hit = process.processIds.includes(props.payload.document.processId);
      return hit;
    });
    const processName = lang === 'ja' ? process.nameJp : process.nameEn;
    const tradingTitle =
      props.payload?.detailInitialData?.tradeManagement?.tradingManageName;

    const pdfSrc = ref(null);
    const selectedTableSchema = ref('goodsLine');
    const tableData = ref([]);
    const itemsTableData = ref([]);
    const localDetailData = ref(props.payload.detailInitialData);
    const isSetting = ref(true); // 初期値の入力
    const isClosing = ref(false);

    // pdf highlights
    const highlights = ref([])
    const activeField = ref(null);

    const goodLineTemplate = ref(null);

    const form = ref(null);
    const formModel = reactive({
      tableData: [],
      itemsTableData: [],
      // 今回のOCR読取が生成した明細配列のパス（保存時の疎ボディ構築に使用）
      ocrTouchedArrayPaths: [],
    });

    const registerTouchedArrays = paths => {
      paths.forEach(path => {
        if (!formModel.ocrTouchedArrayPaths.includes(path)) {
          formModel.ocrTouchedArrayPaths.push(path);
        }
      });
    };

    const activeTab = ref('single');

    // 初期スナップショット（差分比較用）
    const originalTableData = ref([]);

    // ---- 行配列から rules を生成（Composition API なら computed が楽）
    const rules = computed(() => {
      const baseRules = buildRulesFromRows(
        formModel.tableData,
        onEventValidation,
      );
      const itemRules = buildRulesForItems(
        formModel.itemsTableData,
        onEventValidation,
      );
      return {
        ...baseRules,
        ...itemRules,
      };
    });

    const documentManageId = props.payload.document.documentManageId;
    const documentTrx = props.payload.documentTrx;
    const companyId = root.$store.state.userProfile.companyId;
    const processId = props.payload?.detailInitialData?.tradeManagement?.processId;

    const documentLink = computed(() => {
      if(isDocumentTypeInv.value){
        return 'INV';
      }
      if(isDocumentTypeBl.value){
        return 'B/L';
      }
      if(isDocumentTypePl.value){
        return 'P/L';
      }
      if(isDocumentTypePo.value){
        return 'P/O';
      }
      return '';
    });

    const isDocumentTypeInv = computed(() => {
      return props.payload.document.documentLinkInv === 1;
    });
    const isDocumentTypeBl = computed(() => {
      return props.payload.document.documentLinkBl === 1;
    });
    const isDocumentTypePl = computed(() => {
      return props.payload.document.documentLinkPl === 1;
    });
    const isDocumentTypePo = computed(() => {
      return props.payload.document.documentLinkPo === 1;
    });

    const vm = getCurrentInstance().proxy;

    // composable
    const { onEventValidation, validationCheck } = useLakeelValidation(
      root.$store,
      formModel,
      form,
      vm,
    );
    const { loading, data, error } = useBffAiOcrInitial({
      initialQueries: { documentManageId, documentTrx, companyId, processId },
    });

    watch(
      () => data.value,
      newVal => {
        // BFF初期値を保持
        const initialData = _.cloneDeep(props.payload.detailInitialData);

        // 単一項目のマッピング表示用にデータ組み立て
        const updatedTableData = (newVal.aiocrItems || [])
          .map(src => {
            const twNewValue =
              src.twFieldType === 'date'
                ? normalizeDate(src.ocrFieldValue)
                : src.twFieldType === 'number'
                  ? toNumberOrNull(src.ocrFieldValue)
                  : src.ocrFieldValue === ''
                    ? null
                    : src.ocrFieldValue;

            // OCRと現在入力中の差分確認
            const twFieldValue = getValueByPath(initialData, src.twFieldPath);
            // OCRと現在の入力値に差分があるかチェック。もとが空ならアラート出さない
            const hasOcrDiff = normalizeEmpty(twFieldValue)
              ? !_.isEqual(
                  normalizeEmpty(twFieldValue),
                  normalizeEmpty(twNewValue),
                )
              : false;
            //`linkageTransportation.containerGrp.vesselBookingNo` のような構造でAPIから返るのでその形で代入
            setValueByPath(localDetailData.value, src.twFieldPath, twNewValue);

            // pathの情報をもとにラベル他情報を取得
            const info = findFieldInfo(schemaMapping[props.processType] || [], src.twFieldPath);

            return {
              ocrFieldName: src.ocrFieldName,
              ocrFieldValue: src.ocrFieldValue,
              twFieldName: src.twFieldName,
              twFieldType: src.twFieldType,
              twFieldLabel: info?.label,
              twFieldValidationIds: info?.validationId,
              twFieldPath: src.twFieldPath,
              twFieldValue: twFieldValue || '(no data)',
              twNewValue,
              originalValue: twFieldValue,
              ocrFieldSetPage: src.ocrFieldSetPage || null, // ocrFieldSetPageの有無で座標・幅情報の有無を判断
              hasOcrDiff,
              isChanged: false,
            };
          })
          .filter(data => data.twFieldLabel);

        // pdfの座標情報がある単一項目を整理
        const tableDataHighlights = _.filter(newVal.aiocrItems, item => item.ocrFieldSetPage )
        tableData.value = updatedTableData;
        formModel.tableData = updatedTableData;


        // テーブル項目用のpdfハイライト準備
        let itemTableDataHighlights = []

        // テーブル項目 ( 商品 )のマッピング
        if (newVal.aiocrTableItems?.goodsLine.length > 0) {
          const items = newVal.aiocrTableItems?.goodsLine.map(item => {
            const newItem = { ...item };
            for (const key in ITEMS_TYPE_MAP) {
              if (ITEMS_TYPE_MAP[key] === 'number') {
                newItem[key] = toNumberOrNull(item[key]);
              } else {
                newItem[key] = item[key]; // text はそのまま
              }
            }
            return newItem;
          });
          itemsTableData.value = items;
          formModel.itemsTableData = items;
          originalTableData.value = _.cloneDeep(items);

          const newLinkageGoodsLine = mapValuesToGoods(
            newVal.aiocrTableItems?.goodsLine,
            goodLineTemplate.value?.linkageGoodsLine[0],
            // linkageGoodsLineTemplate,
            FIELD_MAP,
          );
          const newLinkageGoodsLinePrice = mapValuesToGoods(
            newVal.aiocrTableItems?.goodsLine,
            goodLineTemplate.value?.linkageGoodsLinePrice[0],
            FIELD_MAP,
          );
          // テーブル項目のハイライト整理 ( 座標が現状一つしか返ってきていないことなどあり、一旦コメントアウト )
          // itemTableDataHighlights = _.filter(newVal.aiocrTableItems?.goodsLine, item => item.ocrFieldSetPage )
          localDetailData.value.linkageGoodsLine = newLinkageGoodsLine;
          localDetailData.value.linkageGoodsLinePrice = newLinkageGoodsLinePrice;
          registerTouchedArrays(['linkageGoodsLine', 'linkageGoodsLinePrice']);
          emit('updateDetailData', localDetailData.value, formModel);

          isSetting.value = false;
        }
        // テーブル項目 ( containerSeals )のマッピング
        if (newVal.aiocrTableItems?.containerSeals.length > 0) {
          const items = newVal.aiocrTableItems?.containerSeals.map(item => {
            const newItem = { ...item };
            for (const key in ITEMS_TYPE_MAP) {
              // ここでセレクトの概念を入れるか、セレクトは別で管理すべきか
              if (ITEMS_TYPE_MAP[key] === 'number') {
                newItem[key] = toNumberOrNull(item[key]);
              } else {
                newItem[key] = item[key]; // text はそのまま
              }
            }

            // Container Typeの入力はContainerSizeとContainerTypeを結合したものを利用
            // SYS_MST_CONTAINER_TYPE 内でcodeとして持っている値と一致する
            // '22' + 'GR' のようにそれぞれ値を持っているものを結合 '22GR'
            newItem.containerCode = '';
            newItem.ocrContainerSize = '';
            newItem.ocrContainerType = '';
            if (item.ocrContainerSize && item.ocrContainerType) {
              // containerCode
              const code = item.ocrContainerSize + item.ocrContainerType;
              const foundType = _.find(SYS_MST_CONTAINER_TYPE, { code });
              if (foundType?.code) {
                newItem.containerCode = foundType?.code || '';
                newItem.ocrContainerSize = foundType?.code.slice(0, 2) || '';
                newItem.ocrContainerType = foundType?.code.slice(2) || '';
              }
            }

            // cargoGrossWeightUnit
            const weightUnit = item.ocrCargoGrossWeightUnit;
            const foundWeightUnit = _.find(CARGO_GROSS_WEIGHT_UNIT_VARIABLES, {
              label: weightUnit,
            });
            newItem.ocrCargoGrossWeightUnit = foundWeightUnit?.code || null;

            // cargoGrossVolumeUnit
            const volumeUnit = item.ocrCargoGrossVolumeUnit;
            const foundVolumeUnit = _.find(CARGO_GROSS_VOLUME_UNIT_VARIABLES, {
              label: volumeUnit,
            });
            newItem.ocrCargoGrossVolumeUnit = foundVolumeUnit?.code || null;
            return newItem;
          });

          selectedTableSchema.value = 'containerSeals';

          emit('changeTab', 'single', selectedTableSchema.value);
          itemsTableData.value = items;
          formModel.itemsTableData = items;
          originalTableData.value = _.cloneDeep(items);

          // 初期値を親に返却
          const template = createContainerSealsBase();
          const newArrayContainerSeals = mapValuesToGoods(
            formModel.itemsTableData,
            template,
            FIELD_MAP_CONTAINER,
          );
          // テーブル項目のハイライト整理 ( 座標が現状一つしか返ってきていないことなどあり、一旦コメントアウト )
          // itemTableDataHighlights = _.filter(newVal.aiocrTableItems?.containerSeals, item => item.ocrFieldSetPage )
          localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals = newArrayContainerSeals;
          registerTouchedArrays([
            'linkageTransportation.containerInfoGrp.arrayContainerSeals',
          ]);
          emit('updateDetailData', localDetailData.value, formModel);
        }

        // P/L時のテーブル項目 (goodsLinePacking)
        if(isDocumentTypePl.value
         && newVal.aiocrTableItems?.goodsLinePacking?.length > 0){

          const items = newVal.aiocrTableItems?.goodsLinePacking.map((item, index) => {
            return parseItemType({
              ...item,
              ...(newVal.aiocrTableItems?.goodsLine[index] || {}), //商品名などはgoodsLineから
              // 荷姿の列（編集可）。反映時に buildGoodsLinePacking でマスタと突き合わせる（PB-2021）
              ocrPlPackingName: item.ocrPlUnit1 || '',
              ocrPlInnerPackingName: item.ocrPlPcsUnit || '',
            });
          });

          selectedTableSchema.value = 'goodsLinePacking';
          emit('changeTab', 'single', selectedTableSchema.value);

          itemsTableData.value = items;
          formModel.itemsTableData = items;
          originalTableData.value = _.cloneDeep(items);

          const {newLinkageGoodsLinePacking, newLinkageGoodsLine, newLinkageGoodsLinePrice} = buildGoodsLinePacking()

          // テーブル項目のハイライト整理 ( 座標が現状一つしか返ってきていないことなどあり、一旦コメントアウト )
          // itemTableDataHighlights = _.filter(newVal.aiocrTableItems?.goodsLinePacking, item => item.ocrFieldSetPage )
          localDetailData.value.linkageGoodsLine = newLinkageGoodsLine;
          localDetailData.value.linkageGoodsLinePrice = newLinkageGoodsLinePrice;
          localDetailData.value.linkageGoodsLinePacking = newLinkageGoodsLinePacking;
          registerTouchedArrays([
            'linkageGoodsLine',
            'linkageGoodsLinePrice',
            'linkageGoodsLinePacking',
          ]);
          emit('updateDetailData', localDetailData.value, formModel);
        }
        // pdfのハイライト情報を整理
        highlights.value = [...tableDataHighlights, ...itemTableDataHighlights]
        // console.log('highlights: ', _.cloneDeep(highlights.value))

      },
    );

    // 荷姿名称の最大長（tw-transaction-api の packing／innerPacking は IS_MAX_LENGTH100）
    const PACKING_NAME_MAX_LENGTH = 100;

    /**
     * 荷姿の文字を梱包種類マスタの表示名と突き合わせる（PB-2021）
     * - 表示名と完全一致（前後の空白を除き、大文字小文字は区別しない）：id＝コード、name＝その行の表示名
     * - 一致しない：id＝null、name＝文字のまま（100文字まで）
     * - 空：id・name とも null
     * コードや説明とは突き合わせない
     */
    const resolvePackageType = text => {
      const trimmed = _.toString(text).trim();
      if (!trimmed) return { id: null, name: null };
      const key = trimmed.toUpperCase();
      const found = _.find(
        SYS_MST_PACKAGE_TYPE,
        type => _.toString(type.value).trim().toUpperCase() === key,
      );
      if (found) return { id: found.code, name: found.value };
      return { id: null, name: trimmed.slice(0, PACKING_NAME_MAX_LENGTH) };
    };

    const parseItemType = (item) => {
      const newItem = {...item};
      for (const key in ITEMS_TYPE_MAP) {
        if (ITEMS_TYPE_MAP[key] === 'number') {
          newItem[key] = toNumberOrNull(item[key]);
        } else {
          newItem[key] = item[key];
        }
      }
      return newItem;
    }

    // 数値変換用ユーティリティ
    // OCR未取得（null/undefined/''）は Number() で 0 と解釈されないよう明示的に null を返す（PB-2004）
    const toNumberOrNull = val => {
      if (val === null || val === undefined || val === '') return null;
      const num = Number(String(val).replace(/,/g, ''));
      return Number.isNaN(num) ? null : num;
    };

    const normalizeEmpty = val => {
      return val === null || val === undefined || val === '' ? null : val;
    };

    const normalizeDate = val => {
      // 20250820 → "2025-08-20"
      if (/^\d{8}$/.test(val)) {
        return dayjs(val, 'YYYYMMDD').format('YYYY-MM-DD');
      }
      return val || null;
    };

    const toBlob = (base64, mimeType) => {
      // 日本語の文字化けに対処するためBOMを作成する。
      var bom = new Uint8Array([0xef, 0xbb, 0xbf]);

      var bin = window.atob(base64.replace(/^.*,/, ''));
      var buffer = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
      }
      // Blobを作成
      try {
        var blob = new Blob([bom, buffer.buffer], {
          type: mimeType,
        });
      } catch (e) {
        return false;
      }
      return blob;
    };

    const fetchPdf = doc => {
      if (doc.documentValue) {
        const blob = toBlob(doc.documentValue, 'application/pdf');
        if (blob) {
          pdfSrc.value = window.URL.createObjectURL(blob);
        }
        return;
      }

      // pdfSrc.value = '@';

      const tag = generateUuid();

      const path = {
        documentManageId: doc.documentManageId,
        documentTrx: doc.documentTrx,
        tag,
      };

      $api
        .download(path, doc.documentName, null, null, false)
        .then(src => {
          pdfSrc.value = src;
        })
        .catch(err => {
          if (err.isCanceled) {
            return;
          }
          root.$store.dispatch('SHOW_ALERT', err.message);
        });
    };

    // レイアウト：itemName だけ 100%、その他は 50%
    const colStyle = field => {
      const key = field.key || field.prop;
      const fullWidthFields = [
        'ocrGoodsShortName',
        'ocrGoodsRefNo1',
        'ocrCountryOfOriginNames',
      ];
      return {
        boxSizing: 'border-box',
        paddingRight: '12px',
        width: fullWidthFields.includes(key) ? '100%' : '50%',
        minWidth: fullWidthFields.includes(key) ? '100%' : '260px',
      };
    };

    const textType = fieldPath => {
      const textareaTarget = [
        'linkageTransportation.shipperGrp.shipperAddress1',
        'linkageTransportation.consigneeGrp.consigneeAddress1',
        'linkageContract.buyerGrp.buyerAddress1',
        'linkageTransportation.notify1Grp.notify1Address1',
        'linkageTransportation.notify2Grp.notify1Address1',
        'linkageTransportation.blGrp.blBody'
      ];
      return _.includes(textareaTarget, fieldPath) ? 'textarea' : 'text';
    };

    const createContainerSealsBase = () => {
      return {
        containerSize: null,
        containerType: null,
        socFlag: null,
        containerComment: null,
        temperatureInformation: null,
        containerNo: null,
        sealNo1: null,
        sealNo2: null,
        sealNo3: null,
        sealNo4: null,
        sealNo5: null,
        sealNo6: null,
        sealingParty1: null,
        sealingParty2: null,
        sealingParty3: null,
        sealingParty4: null,
        sealingParty5: null,
        sealingParty6: null,
        cargoGrossWeight: null,
        cargoGrossWeightUnit: null,
        cargoGrossVolume: null,
        cargoGrossVolumeUnit: null,
        containerTare: null,
        containerWeightUnit: null,
        containerTypeArray: [],
      };
    };

    /**
     * テーブル項目からlinkageGoodsLine/linkageGoodsLinePrice/linkageGoodsLinePackingの組み合わせに変換する
     */
    const buildGoodsLinePacking = () => {
      const goodsLine = createGoodsLine({
        entityId: props.payload?.detailInitialData?.tradeManagement?.entityId,
        tradingId: props.payload?.detailInitialData?.tradeManagement?.tradingId,
        tradingFlowId:
          props.payload?.detailInitialData?.tradeManagement?.tradingFlowId,
        processId: props.payload?.detailInitialData?.tradeManagement?.processId,
        processSeq: parseInt(props.payload?.detailInitialData?.tradeManagement?.processSeq),
      });

      const {newLinkageGoodsLinePacking, newLinkageGoodsLine, newLinkageGoodsLinePrice} = formModel.itemsTableData.reduce(
        (acc, item, index) => {
          const goodsLineSeq = (-1 - index);
          const goodsLineItem = mapValuesToGoodsItem(
            item,
            goodsLine.linkageGoodsLine[0],
            FIELD_MAP,
          );
          goodsLineItem.keyGrp.goodsLineSeq = goodsLineSeq;

          // 荷姿の文字をマスタと突き合わせ、ID と名称に分ける（PB-2021）
          const packing = resolvePackageType(item.ocrPlPackingName);
          const innerPacking = resolvePackageType(item.ocrPlInnerPackingName);
          const goodsLinePackingItem = mapValuesToGoodsItem(
            {
              ...item,
              ocrPlPackingId: packing.id,
              ocrPlPackingName: packing.name,
              ocrPlInnerPackingId: innerPacking.id,
              ocrPlInnerPackingName: innerPacking.name,
            },
            goodsLine.linkageGoodsLinePacking[0],
            FIELD_MAP_GOODS_LINE_PACKING,
          );
          goodsLinePackingItem.keyGrp.goodsLineSeq = goodsLineSeq;

          const newLinkageGoodsLinePriceItem = mapValuesToGoodsItem(
            item,
            goodsLine.linkageGoodsLinePrice[0],
            FIELD_MAP,
          );
          newLinkageGoodsLinePriceItem.keyGrp.goodsLineSeq = goodsLineSeq;

          acc.newLinkageGoodsLine.push(goodsLineItem);
          acc.newLinkageGoodsLinePrice.push(newLinkageGoodsLinePriceItem)
          acc.newLinkageGoodsLinePacking.push(goodsLinePackingItem);
          return acc;
        },
        {newLinkageGoodsLinePacking:[], newLinkageGoodsLine:[], newLinkageGoodsLinePrice:[] }
      );

      return {newLinkageGoodsLinePacking, newLinkageGoodsLine, newLinkageGoodsLinePrice}
    }

    // すべての行について「変更されたキーだけ」を集計
    const buildDiffs = (currentRows, baseRows, schema) => {
      const keys = schema.map(f => f.key || f.prop).filter(Boolean);
      const diffs = [];
      for (let i = 0; i < currentRows.length; i++) {
        const cur = currentRows[i] || {};
        const base = baseRows[i] || {};
        const changed = {};
        keys.forEach(k => {
          if (!_.isEqual(cur[k], base[k])) {
            changed[k] = _.cloneDeep(cur[k]);
          }
        });
        if (!_.isEmpty(changed)) {
          diffs.push({ rowIndex: i, changed });
        }
      }
      return diffs;
    };

    const isDirtyRow = (rowIndex, key) => {
      return (
        formModel.itemsTableData[rowIndex][key] !==
        originalTableData.value[rowIndex][key]
      );
    };

    // 変更時：その場で差分だけ emit
    const onInput = (rowIndex, field) => {
      const key = field.prop;
      const val = _.cloneDeep(formModel.itemsTableData[rowIndex][key]);

      // 数値のものは数値化
      formModel.itemsTableData[rowIndex][key] =
        field.type === 'number'
          ? Number.isNaN(Number(val))
            ? val
            : Number(val)
          : val;

      const current = formModel.itemsTableData[rowIndex][key];
      const base = (originalTableData.value[rowIndex] || {})[key];

      // 差分があれば、1行分の changed オブジェクトを作る
      const changed = {};
      if (!_.isEqual(current, base)) {
        changed[key] = _.cloneDeep(current);
      } else {
        // 元に戻したら差分からは外す → emit 側で最終的な集計に任せる
      }
      // 1フィールド単位イベント
      emit('field-change', { rowIndex, key, value: _.cloneDeep(current) });
      // 行単位の差分（そのキーのみ）
      if (!_.isEmpty(changed)) {
        emit('row-change', { rowIndex, changed });
      }
      // 全体の差分配列（都度再計算）
      const diffs = buildDiffs(
        formModel.itemsTableData,
        originalTableData.value,
        tableSchemas[selectedTableSchema.value],
      );

      if (diffs.length > 0) {
        if (selectedTableSchema.value === 'goodsLine') {
          const newLinkageGoodsLine = mapValuesToGoods(
            formModel.itemsTableData,
            goodLineTemplate.value.linkageGoodsLine[0],
            FIELD_MAP,
          );
          const newLinkageGoodsLinePrice = mapValuesToGoods(
            formModel.itemsTableData,
            goodLineTemplate.value.linkageGoodsLinePrice[0],
            FIELD_MAP,
          );

          localDetailData.value.linkageGoodsLine = newLinkageGoodsLine;
          localDetailData.value.linkageGoodsLinePrice = newLinkageGoodsLinePrice;
        }
        if (selectedTableSchema.value === 'containerSeals') {
          const template = createContainerSealsBase();
          const newArrayContainerSeals = mapValuesToGoods(
            formModel.itemsTableData,
            template,
            FIELD_MAP_CONTAINER,
          );
          localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals = newArrayContainerSeals;
        }

        if(selectedTableSchema.value === 'goodsLinePacking'){
          const {newLinkageGoodsLinePacking, newLinkageGoodsLine, newLinkageGoodsLinePrice} = buildGoodsLinePacking()
          localDetailData.value.linkageGoodsLine = newLinkageGoodsLine;
          localDetailData.value.linkageGoodsLinePrice = newLinkageGoodsLinePrice;
          localDetailData.value.linkageGoodsLinePacking = newLinkageGoodsLinePacking;
        }
        // console.log('localData: ', _.cloneDeep(localDetailData.value));
        emit('updateDetailData', localDetailData.value, formModel);
      }
      emit('changeItemsTable', diffs);
    };

    const onChangeContainerType = (code, index, key) => {
      // codeを数値とその他で分解
      const size = code.slice(0, 2);
      const type = code.slice(2);
      formModel.itemsTableData[index].ocrContainerSize = size;
      formModel.itemsTableData[index].ocrContainerType = type;
      localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals[
        index
      ].containerSize = size;
      localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals[
        index
      ].containerType = type;
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const onChangeCurrency = (code, index, key) => {
      formModel.itemsTableData[index][key] = code;
      localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals[
        index
      ][key] = code;
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const onChangeUnit = (code, index, key) => {
      formModel.itemsTableData[index].OCR_cargoGrossWeightUnit = code;
      localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals[
        index
      ][key] = code;
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const onChangWeightUnit = (code, index, key) => {
      formModel.itemsTableData[index].ocrPlWeightUnit = code;
      localDetailData.value.linkageGoodsLinePacking[index].netGrossMeasurementGrp.weightUnit = code;
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const onChangeMsmtUnit = (code, index, key) => {
      formModel.itemsTableData[index].ocrPlMeasurementUnit = code;
      localDetailData.value.linkageGoodsLinePacking[index].netGrossMeasurementGrp.measurementUnit = code;
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const getValueByPath = (obj, path) => {
      return path.split('.').reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
      }, obj);
    };

    const handleInput = row => {
      row.isChanged = row.twNewValue !== row.originalValue;
      setValueByPath(localDetailData.value, row.twFieldPath, row.twNewValue);
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const setValueByPath = (obj, path, value) => {
      const keys = path.split('.');
      const lastKey = keys.pop();
      let acc = obj;
      for (const key of keys) {
        if (acc[key] === undefined || typeof acc[key] !== 'object') {
          acc[key] = {}; // 中間が無ければオブジェクトを作る
        }
        acc = acc[key];
      }
      acc[lastKey] = value;
    };

    const handleUpdateTableData = data => {
      // console.log("handleUpdateTableData: ", data)
    };

    /**
     * mapValuesToGoodsをオブジェクト単体で扱うためのラッパー
     * @param item 対象データ
     * @param template 対象テンプレート
     * @param fieldMap キー一覧
     */
    const mapValuesToGoodsItem = (item, template, fieldMap) => {
      const convertItem = mapValuesToGoods([item], template, fieldMap);
      return convertItem[0] || {};
    }

    const mapValuesToGoods = (values, template, fieldMap) => {
      return values.map((src, i) => {
        // 元のテンプレートをコピー（変更しないため deep clone）
        const row = JSON.parse(JSON.stringify(template));

        // マッピングに従って上書き
        for (const [srcKey, dstPath] of Object.entries(fieldMap)) {
          if (src[srcKey] !== undefined) {
            let val;
            const type = ITEMS_TYPE_MAP[srcKey];
            if (type === 'number') {
              // OCR未取得（null）や数値変換に失敗した文字列（単位混在など）を
              // Number(null) === 0 のように誤って0にすると既存値を上書きしてしまう（PB-2004）ため、
              // toNumberOrNullに統一し、確定できない値は一律nullにする。
              val = toNumberOrNull(src[srcKey]);
            } else {
              val = src[srcKey] === '' ? null : src[srcKey];
            }
            setValueByPath(row, dstPath, val);
          }
        }
        return row;
      });
    };

    /**
     * 指定されたパス文字列から対象の children を探し、validationId と label を返す
     * @param {Object} schemaData - ルートのオブジェクト（例: { tables: [...] }）
     * @param {string} pathStr - パス文字列（例: "linkageContract.paymentTermsGrp.paymentTerms1"）
     * @returns {Object|null} - { validationId, label } または null
     */
    const findFieldInfo = (schemaData, pathStr) => {
      if(isEmpty(schemaData)){
        return null;
      }
      const parts = pathStr.split('.'); // ["linkageContract", "paymentTermsGrp", "paymentTerms1"]
      if (parts.length < 3) return null;
      const [tableVar, groupVar, fieldKey] = parts;
      // 1. table 探索
      const table = schemaData.tables.find(t => t.variableName === tableVar);
      if (!table) return null;
      // 2. group 探索
      const group = table.groups.find(g => g.variableName === groupVar);
      if (!group) return null;
      // 3. children 探索
      const field = group.children.find(c => c.key === fieldKey);
      if (!field) return null;
      // 4. 必要な情報を返却
      return {
        validationId: field.validationId,
        label: field.label,
      };
    };

    const buildRulesFromRows = (rows, validator) => {
      const result = {};
      rows.forEach((row, idx) => {
        const propPath = `tableData.${idx}.twNewValue`;
        // select/radio などで trigger を切り替えたい場合は row.inputType を使って分岐
        const trigger = 'blur';
        result[propPath] = [
          {
            lakeelMessageSourceFlg: true,
            validationId: row.twFieldValidationIds,
            validator,
            trigger,
            field: row.twFieldName,
            label: row.twFieldLabel || row.twFieldName,
          },
        ];
      });
      return result;
    };

    // 綴りブレ対応: amoutPerItem → amountPerItem
    const normalizeKey = key =>
      key === 'amoutPerItem' ? 'amountPerItem' : key;

    const buildRulesForItems = (
      rows,
      validator,
      basePath = 'itemsTableData',
    ) => {
      const result = {};
      rows.forEach((row, idx) => {
        // 本行で取り扱うキーだけ抽出（定義済み + 行に存在するもの）
        Object.keys(row).forEach(rawKey => {
          const key = normalizeKey(rawKey);
          if (!VALIDATION_BY_KEY[key]) return;
          const propPath = `${basePath}.${idx}.${key}`;
          const trigger = 'blur';
          result[propPath] = [
            {
              lakeelMessageSourceFlg: true,
              validationId: VALIDATION_BY_KEY[key],
              validator,
              trigger,
              field: key,
              label: key,
            },
          ];
        });
      });
      return result;
    };

    // itemsTableData 全行・全キーから prop 配列を作る
    const buildAllItemProps = () => {
      const props = [];
      formModel.itemsTableData.forEach((row, rowIndex) => {
        if (!row) return;
        Object.keys(row).forEach(key => {
          props.push(`itemsTableData.${rowIndex}.${key}`);
        });
      });
      return props;
    };

    // 選択中のタブ情報を親に返却
    const handleTabClick = tab => {
      emit('changeTab', tab.name, selectedTableSchema.value);
    };

    // テーブル項目の削除
    const handleCloseItems = index => {
      isClosing.value = true;
      // 1. まず itemsTableData 全体のバリデーション状態をクリア
      if (form.value) {
        const props = buildAllItemProps();
        if (props.length > 0) {
          form.value.clearValidate(props);
        }
      }
      // 2. 表示用フォームモデルを削除
      formModel.itemsTableData.splice(index, 1);
      originalTableData.value.splice(index, 1);

      // 3. 実際の詳細データも削除
      if (selectedTableSchema.value === 'goodsLine') {
        localDetailData.value.linkageGoodsLine.splice(index, 1);
        localDetailData.value.linkageGoodsLinePrice.splice(index, 1);
      } else if (selectedTableSchema.value === 'goodsLinePacking'){
        localDetailData.value.linkageGoodsLinePacking.splice(index, 1);
        localDetailData.value.linkageGoodsLine.splice(index, 1);
        localDetailData.value.linkageGoodsLinePrice.splice(index, 1);
      } else {
        localDetailData.value.linkageTransportation.containerInfoGrp.arrayContainerSeals.splice(
          index,
          1,
        );
      }
      setTimeout(() => {
        isClosing.value = false;
      }, 500);
      emit('updateDetailData', localDetailData.value, formModel);
    };

    const setHighlightItem = ( row, kind ) => {
      // console.log(row)
      if ( !row.ocrFieldSetPage ) return
      // console.log('activeItem: ', row);
      // console.log(data.value.aiocrItems)
      const activeItem = _.find(
        kind === 'single' ? data.value.aiocrItems : kind === 'goodsLine' ? data.value.aiocrTableItems.goodsLine : data.value.aiocrTableItems.containerSeals,
        item => item.twFieldPath === row.twFieldPath,
      );
      // console.log(activeItem);
      activeField.value = activeItem;
    };

    const clearHighlightItem = row => {
      if ( !row.ocrFieldSetPage ) return
      activeField.value = null
    }

    onMounted(() => {
      // BFFからの返り値を上記のロジックで調整
      // 結合した形で見つからなければモデルを空にしてセレクトを表示。modelのキーはcode
      // 選択した場合は、選択されたcodeをもとにMASTERから探して分けて保存できるように管理する

      if (props.payload.document) fetchPdf(props.payload.document);
      props.validationCheck(validationCheck);
      // 商品テンプレート
      const goodsLine = createGoodsLine({
        selectGoods: null,
        goodsTypeMasterList: null,
        goodsLineId: null,
        lastGoodsLineSeq: 0,
        entityId: props.payload?.detailInitialData?.entityId,
        tradingId: props.payload?.detailInitialData?.tradeManagement?.tradingId,
        tradingFlowId:
          props.payload?.detailInitialData?.tradeManagement?.tradingFlowId,
        processId: props.payload?.detailInitialData?.processId,
        processSeq: parseInt(props.payload?.detailInitialData?.processSeq),
      });
      goodLineTemplate.value = goodsLine;
    });

    return {
      lang,
      SYS_MST_CONTAINER_TYPE,
      SYS_MST_UNIT,
      SYS_MST_CURRENCY,
      CARGO_GROSS_WEIGHT_UNIT_VARIABLES,
      CARGO_GROSS_VOLUME_UNIT_VARIABLES,
      documentLink,
      activeTab,
      tradingTitle,
      processName,
      pdfSrc,
      highlights,
      activeField,
      singleSchema,
      tableSchemas,
      textType,
      selectedTableSchema,
      isSetting,
      isClosing,
      loading,
      itemsTableData,
      rules,
      form,
      formModel,
      tableData,
      colStyle,
      normalizeKey,
      isDirtyRow,
      onInput,
      onChangeContainerType,
      onChangeUnit,
      onChangeCurrency,
      onChangWeightUnit,
      onChangeMsmtUnit,
      handleInput,
      handleUpdateTableData,
      handleTabClick,
      handleCloseItems,
      setHighlightItem,
      clearHighlightItem,
    };
  },
});
</script>

<style scoped>
.aiOcrLabel {
  width: 120px;
  background-color: #d9ecff;
  color: #9191a4;
  margin-right: 8px;
  padding: 2px 4px;
  border-radius: 2px;
}
.row-card {
  border: 1px solid #eee;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  position: relative;
}
.row-card__shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 40%,
    rgba(255, 255, 255, 0) 80%
  );
  animation: shimmer 1.2s infinite;
  pointer-events: none;
}
/* カード自体もちょっと暗くする */
.row-card--loading {
  opacity: 0.7;
}
/* シマーアニメーション */
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(120%);
  }
}
.fields {
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
  flex-grow: 1;
}
::v-deep .el-form-item__label {
  font-size: 12px;
  line-height: 24px;
}

::v-deep .ai-ocr-items .el-form-item__label {
  display: none;
}

::v-deep .el-textarea__inner {
  box-shadow: inset 2.5px 2.5px 5px rgba(170, 170, 204, 0.5);
}

::v-deep .el-table .el-form-item__error {
  white-space: normal;
  position: static;
}

::v-deep .el-input input::-webkit-outer-spin-button,
::v-deep .el-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep .el-select {
  width: 100%;
}

.dialog-body {
  display: flex;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
}

/* 左右レイアウト */
.left-pane {
  width: 55%;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
}
.right-pane {
  width: 45%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* PDF 埋め込みが親の高さいっぱいに */
.pdfViewer {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
}
.pdfViewer embed {
  flex: 1 1 auto;
}

::v-deep .tabs-fill {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

::v-deep .tabs-fill > .el-tabs__content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

::v-deep .el-tab-pane {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.pane-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-right: 8px;
}

/* スクロールバー全体 */
.pane-scroll::-webkit-scrollbar {
  width: 8px; /* 横幅 */
}
/* スクロールバーの背景（トラック部分） */
.pane-scroll::-webkit-scrollbar-track {
  background: transparent; /* 背景透明 */
}
/* スクロールする部分（サム部分） */
.pane-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15); /* ← 薄いグレー */
  border-radius: 4px;
}
/* ホバーしたときに少し濃くする */
.pane-scroll:hover::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
}
</style>
